import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { LoadingScreen } from 'scenes/Dashboard/components-next/Loading'
import { Redirect, Route, Switch } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent } from '@mui/material'

import { SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH } from '../../ScoutingCampaignManager.routes'
import {
  getScoutingCampaignDetailsFormDataPath,
  SCOUTING_CAMPAIGN_MANAGER_DETAILS_FORM_DATA_PATH,
  SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_LIST_PATH,
  SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_RESULTS_PATH,
} from './ScoutingCampaignDetailsView.routes'
import { useScoutingCampaignDetailsViewStore } from './ScoutingCampaignDetailsView.store'
import { ScoutingCampaignDetailsFormView } from './scenes'
import { SearchCandidatesList } from './scenes/SearchCandidatesList/SearchCandidatesList.component'
import { SearchCandidateResults } from './scenes/SearchCandidateResults/SearchCandidateResults.component'

export type ScoutingCampaignDetailsViewContentProps = ExtendableStyles & Testable

export function ScoutingCampaignDetailsViewContent({
  className,
  style,
  ...otherProps
}: ScoutingCampaignDetailsViewContentProps) {
  const {
    state: { scoutingCampaignId },
  } = useScoutingCampaignDetailsViewStore()
  return (
    <section className={className}>
      <CardContent {...otherProps}>
        <Suspense fallback={<LoadingScreen />}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Switch>
              <Route path={SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH} exact>
                <Redirect to={getScoutingCampaignDetailsFormDataPath(scoutingCampaignId)} />
              </Route>
              <Route
                path={SCOUTING_CAMPAIGN_MANAGER_DETAILS_FORM_DATA_PATH}
                component={ScoutingCampaignDetailsFormView}
                exact
              />
              <Route
                path={SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_LIST_PATH}
                component={SearchCandidatesList}
                exact
              />
              <Route
                path={SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_RESULTS_PATH}
                component={SearchCandidateResults}
                exact
              />
            </Switch>
          </ErrorBoundary>
        </Suspense>
      </CardContent>
    </section>
  )
}

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <pre>{error.stack}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  )
}
